// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const OrderQuoteStatus = {
  Known: {
    Name: 'Known',
    Value: 'known',
  },
  Pending: {
    Name: 'Pending',
    Value: 'pending',
  },
  Unavailable: {
    Name: 'Unavailable',
    Value: 'unavailable',
  },
} as const

export type OrderQuoteStatusValue =
  (typeof OrderQuoteStatus)[keyof typeof OrderQuoteStatus]['Value']
